import React, { Fragment, useState, createRef } from 'react'
import "./share.css";
import { faImage, faVideo, faSmile } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAvtar }  from "../utils"
import { FileSelection } from '../../../../containers/Files';
import { showLoader } from '../../../../store/actions/loader';
import { AlertJsMessage } from '../../../../helpers.js';
import COLORS from '../../../../styles/colors';
import { VALIDATION_MESSAGES } from '../../../../static-content';
import Button from '@material-ui/core/Button';
import Compressor from 'compressorjs';
import AWS_S3 from 'aws-sdk/clients/s3';
import Badge from '@material-ui/core/Badge';
import { withStyles, styled } from '@material-ui/core/styles';
import EmojiButton from './../../../EmojiButton';
import { 
	S3_BUCKET_NAME, 
	IMAGE_SIZE_LIMIT_BYTES, 
	VIDEO_SIZE_LIMIT_BYTES,
	MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES, 
	TOPIC_VIDEO_SIZE_LIMIT_BYTES 
  } from '../../../../constants';

const acceptTypes = {
  mixed: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov'],
  video: ['video/mp4', 'video/quicktime', 'video/mov'],
  image: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
  audio: ['.mp3', '.m4a']
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
      right: 0,
      top: 0,
      backgroundColor: 'rgb(234, 94, 1)',
      fontSize: '10px'
  },
}));


class CommentForm extends React.Component {
  
    constructor(props) {
		super(props);
		this.state = {
			submitAction: 'create',
			editItem: null,
			formData: {
				description: ''
			},
		};
	}

	componentDidMount() {
		if(this.props.editId) {
			this.props.fetch(this.props.editId, 'comment').then((res) => {
				this.setState({
					...this.state,
					submitAction: 'edit',
					editItem: res,
					formData: {
						description: res.description
					},
					dataLoaded: true,
				})
			});
		}
	  }

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value
				
			}
		});
	};

	validateForm() {
        const { formData } = this.state;
        const { history, isMedia, isFormFields } = this.props;
        if(isFormFields) {
            const required = [
            'description'
            ];
            for (var i = 0; i < required.length; i++) {
                if (!formData[required[i]]) {
                    AlertJsMessage(VALIDATION_MESSAGES['TOPIC'][required[i]]);
                    return;
                }
            }
        }
        this.submitValidatedForm(formData);
     }
	
	submitValidatedForm(formData) {
		const { history, editId, topicId, postId } = this.props;
		const { editItem } = this.state;
		formData.topicId = topicId;
    formData.postId = postId;
    if (this.state.submitAction === 'create') {
      this.props.create('comment', formData).then((res) => {
        const _id = res.data.id;
        this.props.onSaveComment(res.data, true);
        this.setState({
          ...this.state,
          formData: {
            ...this.state.formData,
            description: ''
          }
        })
        
      });
    }
		if (this.state.submitAction === 'edit') {
		  this.props.edit('comment', { ...formData, id: editId }).then((res) => {
    	  this.props.onSaveComment(res.data, false);
		  });
		}
  }

  _handleKeyDown = (e) =>  {
    if (e.key === 'Enter') {
       this.validateForm();
    }
  }

  passEmoji = (emoji) => {
    const cursor = this.inputRef.selectionStart;
    const description = this.state.formData.description;
    const text = description.slice(0, cursor) + emoji + description.slice(cursor);
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        description: text
      }
      })
    }
  

  render() {
    const { formData, editItem, previewVideoSrc, previewImageSrc, fileLoaded, isSubmitNewFile } = this.state;
	  const { isMedia, isFormFields, isMixedAsset, isMobile, classes, user } = this.props;
    return (
      <div>
        <div className="shareWrapper">
          <div className="shareTop commentInput">
            { user && 
              getAvtar(user)
            }
           

            <input
              type= "text"
              placeholder="Write a Comment ..."
              value={formData.description}
              onChange={this.handleChange('description')}
              onKeyDown={this._handleKeyDown}
              className="shareInput"
              ref={(ref) => { this.inputRef = ref  }}
            />
            <span style={{marginLeft: 10}}>
              <EmojiButton passEmoji = {this.passEmoji}></EmojiButton>
             </span>
          </div>
          <hr className="shareHr"/>
          
        </div>
      </div>
    );
  }
}

export default  CommentForm;


// WEBPACK FOOTER //
// ./src/components/social/shared/share/CommentForm.jsx